import { render, staticRenderFns } from "./IlluCoachingScolaire.vue?vue&type=template&id=cba094aa&"
import script from "./IlluCoachingScolaire.vue?vue&type=script&lang=js&"
export * from "./IlluCoachingScolaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports